import { useState } from "react";
import { Run } from "./Run";
import { createEntityStore } from "../../common/entityStore";
import { Grid } from "@mui/material";
import { propFileField } from "../../common/entityStoreForm";
import { propRequired, propValueValidator } from "../../common/entityStoreValidators";

export function MailOrderCopyRunPage() {
    const [useParamsStore] = useState(() => createEntityStore<RunParams>({
        data: {},
        id: null,
        propValidators: [
            propRequired("file"),
            propValueValidator("isFileImported", p => p && "File is already imported."),
        ]
    }));
    const [isRunning, setIsRunning] = useState(false);
    function renderParams() {
        return <>
            <Grid item xs={12}>{propFileField(useParamsStore)("file", "File", { disabled: isRunning, onChange: () => useParamsStore.getState().setClientDataProp("isFileImported", undefined) })}</Grid>
        </>;
    }
    return <Run name="Batch MO copy" hub="mailOrderCopyRun" onRunFinished={p => p && useParamsStore.getState().setClientDataProp("isFileImported", true)}
        useParamsStore={useParamsStore} renderParams={renderParams} setIsRunning={setIsRunning} />;
}

interface RunParams {
    file?: File;
    isFileImported?: boolean;
}
